export default "__VITE_ASSET__CNJZf2LR__"